import Vue from 'vue';
import BaseProxy from './base-proxy';


/**
 * Class TagProxy
 */
class TagProxy extends BaseProxy {
  /**
   * Constructor.
   *
   * @param {Object} parameters The query parameters.
   */
  constructor(parameters = {}) {
    super('/invoice-robotics-api/api', parameters);
  }

  getTags(dirIds, options = {}) {
    return this.submit('post', `${this.endpoint}/get-all-tags`, null, options);
  }

  createTag(tag) {
    const toast = {
      success: Vue.i18n.t('app.createSuccess'),
    };
    return this.submit('post', `${this.endpoint}/create-tag`, tag, {
      toast,
    });
  }

  updateTag(invoice) {
    const toast = {
      success: Vue.i18n.t('app.updateSuccess'),
    };
    return this.submit('post', `${this.endpoint}/update-tag`, invoice, { toast });
  }

  deleteTag(id) {
    const toast = {
      success: Vue.i18n.t('app.deleteSuccess'),
    };
    return this.submit('post', `${this.endpoint}/delete-tag`, { id }, { toast });
  }

  /* ================================================= ACCESS LIST ================================================= */

  createTagAccessList(payload) {
    const toast = {
      success: Vue.i18n.t('app.createSuccess'),
    };
    return this.submit('post', `${this.endpoint}/create-tag-access-list`, payload, { toast });
  }

  updateTagAccessList(payload) {
    const toast = {
      success: Vue.i18n.t('app.updateSuccess'),
    };
    return this.submit('post', `${this.endpoint}/update-tag-access-list`, payload, { toast });
  }

  deleteTagAccessList(listId) {
    const toast = {
      success: Vue.i18n.t('app.deleteSuccess'),
    };
    return this.submit('post', `${this.endpoint}/delete-tag-access-list`, { tag_access_lists: listId }, { toast });
  }

  getOwnerTagAccessList() {
    return this.submit('post', `${this.endpoint}/get-owner-tag-access-list`);
  }

  getMemberTagAccessList() {
    return this.submit('post', `${this.endpoint}/get-member-tag-access-list`);
  }
}

export default TagProxy;



// WEBPACK FOOTER //
// ./src/store/proxies/tag-proxy.js